import React from 'react';

import { Accordion, AccordionDetails, AccordionSummary, Link, Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Skeleton } from '@material-ui/lab';
import styled from 'styled-components';
import { Container } from 'styles/admin';
import { StyledTypography } from 'styles/common';

const obj = {
  title: 'User Guide',
  sections: [
    {
      title: 'Goals and task management',
      questionAnswers: [
        {
          question: 'How do I add a new goal?',
          answer: [
            [
              {
                type: 'text',
                content: `Adding a new goal in Mesh is very simple.`,
              },
            ],
            [
              {
                type: 'text',
                content: `1. Go to the  ‘Mesh List’, the right most section of your Mesh homepage.`,
              },
            ],
            [
              {
                type: 'text',
                content: `Click on the ‘Goals’ tab, and click on ‘Add a new goal’ button.`,
              },
            ],
            [
              {
                type: 'text',
                content: `Once you add a goal, you can choose to attach the goal to a company objective. Click on the objective button and select a relevant objective from the drop down menu.
            `,
              },
            ],
            [
              {
                type: 'text',
                content: `If you don’t find a relevant objective, you can create a new one by clicking on the ‘Create new’ button.`,
              },
            ],
            [
              {
                type: 'text',
                content: `We suggest discussing with your manager to align your goals with appropriate objectives.`,
              },
            ],
            [
              {
                type: 'text',
                content: `For more detailed information on various options of the goal panel here - `,
              },
              {
                type: 'link',
                href: `https://link.thepeoplemesh.com/user-guide`,
                content: `https://link.thepeoplemesh.com/user-guide`,
              },
            ],
          ],
        },
      ],
    },
  ],
};

export const AnswerParagraph = (paragraph) => (
  <StyledTypography
    as="pre"
    color="textSecondary"
    variant="body2"
    topGutter={1}
    bottomGutter={1}
    style={{ fontFamily: 'inherit' }}
  >
    {paragraph.map(({ type, content, href }) => {
      switch (type) {
        case 'text':
          return <span> {content} </span>;
        case 'link':
          return <Link href={href}> {content} </Link>;
        default:
      }
    })}
  </StyledTypography>
);

export const Section = ({ title, questionAnswers }) => (
  <>
    <StyledTypography color="textPrimary" variant="subtitle1" weight="bold" topGutter={2} bottomGutter={2}>
      {title}
    </StyledTypography>
    {questionAnswers.map(({ question, answer }, index) => (
      <Accordion key={index}>
        <StyledAccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel-${index}-content`}
          id={`panel-${index}-header`}
        >
          <StyledTypography variant="body1">{question}</StyledTypography>
        </StyledAccordionSummary>
        <StyledAccordionDetails>{answer.map((para) => AnswerParagraph(para))}</StyledAccordionDetails>
      </Accordion>
    ))}
  </>
);

export const Page = ({ title: PageTitle, sections, isLoading }) => (
  <Container>
    <StyledTypography variant="h6" weight="bold" color="primary">
      {PageTitle}
    </StyledTypography>
    <StyledPaper>
      {isLoading ? (
        <Loader />
      ) : sections.length > 0 ? (
        sections.map(({ title, questionAnswers }, index) => (
          <Section key={index} title={title} questionAnswers={questionAnswers} />
        ))
      ) : (
        <StyledTypography variant="body1" align="center">
          Nothing to display
        </StyledTypography>
      )}
    </StyledPaper>
  </Container>
);

export const Loader = () => (
  <SkeletonContainer>
    <Skeleton width="90%" />
    <Skeleton width="70%" />
    <Skeleton width="90%" />
  </SkeletonContainer>
);

const SkeletonContainer = styled.div``;

const StyledAccordionDetails = styled(AccordionDetails)`
  display: block;
  padding-left: 1rem;
  padding-right: 1rem;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: ${(props) => props.theme.palette.background.grey};
`;

const StyledPaper = styled(Paper)`
  margin-top: 1em;
  padding: 2rem;
  padding-top: 1rem;
`;
